import isEqual from 'lodash.isequal'

export default {
    props: {
        heading: {
            type: String,
            required: true
        },
        options: {
            type: [Array, Object],
            required: true
        },
        index: {
            type: String,
            required: true
        },
        activeFilters: {
            type: Object,
            required: true,
        },
        validFilters: {
            type: Array,
            required: true,
        },
        canBeDisabled: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({}),
    methods: {
        filterReset() {
            this.$emit('filter-reset', this.index)
        },
        toggleFilter(val, unit) {
            //TODO find a way to mutate index onto the event data in the parent component (it should be able to contextually tell what filter the options are being toggled on)
            this.$emit('toggle-filter', this.index, val, unit)
        },
        filterInUse(option) {
            const active_options = this.activeFilters?.vals || []

            // check that active filters contain this option
            return active_options.find(element => isEqual(element, option))
        },
        optionDisabled(option) {
            //disabled option if this filter set can be disabled AND if the valid filters do not contain this option
            return !this.validFilters
                .find(element => JSON.stringify(element) === JSON.stringify(option))
        },
        inputStyle() {
            return {
                'text-grey': false
            }
        },
    },
    computed: {},
    watch: {},
}
